import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { Icon, List, Grid, Card, Button, Label } from 'semantic-ui-react';
import Header from 'components/Header';
import InlineEditIconButton from 'components/InlineEditIconButton';
import Message from 'components/Message';
import BackLink from 'components/BackLink';
import CancelGoButtons from 'components/CancelGoButtons';
import SubmitButton from 'components/SubmitButton';
import BillProducts from './ui/BillProducts';
import BillSummary from './ui/BillSummary';
import API from 'utils/api';
import formatter from 'utils/formatter';
import { displayTitle, hasBillLabel } from 'utils/billDisplay';
import AddOrdersMenu from './ui/AddOrdersMenu';
import TimeAgo from 'timeago-react';
import { register } from 'timeago.js';
import es from 'timeago.js/lib/lang/es';

class BillPage extends React.Component {
  constructor(props) {
    super(props);

    // Register the Spanish locale
    register('es', es);

    this.state = {
      billId: null,
      bill: {
        name:"",
        orders: []
      },
      ordersInMenu: [],
      showBillReceipt: false,
      showBillDeliveredConfirmation: false,
      showMenu: false,
      showDeleteConfirmation: false,
      menuEditOrder: null
    };
  }
  
  componentDidMount() {
    const billId = parseInt(this.props.match.params.billId);
    this.setState({ billId }, this.getBill);
  }

  getBill = () => {
    API.getBill(this.state.billId)
      .then((response) => {
        this.setState({
          bill: response.data,
          ordersInMenu: response.data.orders
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  toggleProductReady = (productId) => {
    API.toggleProductReady(productId)
      .then((response) => {
        this.getBill();
      })
      .catch((error) => {
        console.error(error);
      });
  }

  billPaid = () => {
    API.billPaid(this.state.billId)
      .then((response) => {
        this.setState({
          showBillReceipt: false
        }, this.getBill);
      })
      .catch((error) => {
        console.error(error);
      })
  }

  deliverBill = () => {
    this.setState({ showBillDeliveredConfirmation: true });
  }

  billDelivered = () => {
    API.billDelivered(this.state.billId)
      .then((response) => {
        this.props.history.push('/bills');
      })
      .catch((error) => {
        console.error(error);
      });
  }

  deleteBill = () => {
    API.deleteBill(this.props.match.params.billId)
      .then((response) => {
        this.props.history.push('/bills');
      })
      .catch((error) => {
        console.error(error);
      });
  }

  // Add a helper function to show delete confirmation
  showDeleteConfirmation = () => {
    this.setState({ showDeleteConfirmation: true });
  }
  
  render() {
    if (!this.state.bill) { return null }

    const pendingOrders = this.state.bill.orders.filter(order => !order.delivered_at);

    // when an order has been closed (paid and delivered)
    if (this.state.bill.paid_at && this.state.bill.delivered_at) {
      return (
        <div>
          <div>
            <Header text={displayTitle(this.state.bill)} subtitle={this.state.bill.note} inlineSubtitle={true} />
          </div>

          <div style={{ marginBottom: '1em', fontSize: '24px' }}>
            { formatter.currency(this.state.bill.total) }
          </div>
        
          <Card fluid>
            <Card.Content>
              <List divided relaxed>
                { this.state.bill.orders.map((order) => 
                  <List.Item key={order.id}>
                    <Grid>
                      <Grid.Row>
                        <Grid.Column width={12} verticalAlign="top">
                          <p style={{ fontSize: '1em', marginBottom: 0 }}>
                            { order.product_name }
                          </p>
                          { (order.quantity > 1) &&
                            <p style={{ fontSize: '1em', marginBottom: 0 }}>
                              x {order.quantity}
                            </p>
                          }
                        </Grid.Column>
                        
                        <Grid.Column width={4} verticalAlign="top" textAlign="right">
                          <p style={{ fontSize: '1em', marginBottom: 0, color: (order.quantity > 1 ? 'gray' : '') }}>
                            { formatter.currency(order.unit_price) }
                          </p>
                          { (order.quantity > 1) &&
                            <p style={{ fontSize: '1em', marginBottom: 0 }}>
                              {formatter.currency((order.quantity * order.unit_price))}
                            </p>
                          }
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </List.Item>
                )}
              </List>
            </Card.Content>
          </Card>

          <div style={{ marginBottom: '0.5em', marginTop: '1.5em', color: 'gray' }}>
            <span>
              <Icon name="clock outline" size='large' />
              <span style={{ marginRight: '5px'}}>
                Entregado
              </span>
              <TimeAgo
                datetime={this.state.bill.delivered_at}
                locale="es"
              />
            </span>
          </div>

          <div style={{ marginBottom: '0.5em', color: 'gray' }}>
            <span>
              <Icon name="clock outline" size='large' />
              <span style={{ marginRight: '5px'}}>
                Pagado
              </span>
              <TimeAgo
                datetime={this.state.bill.paid_at}
                locale="es"
              />
            </span>
          </div>

          <div style={{  color: 'gray' }}>
            <span>
              <Icon name="clock outline" size='large' />
              <TimeAgo
                datetime={this.state.bill.created_at}
                locale="es"
              />
            </span>
          </div>
          
          <BackLink onClick={() => this.props.history.push('/bills')} />
        </div>
      )
    }

    // when an order is being paid
    if (this.state.showBillReceipt) {
      return (
        <BillSummary
          bill={this.state.bill}
          orders={this.state.bill.orders}
          cancelFn={ () => this.setState({ showBillReceipt: false }) }
          billPaidFn={this.billPaid}
        />
      )
    }

    // when an order is being delivered
    if (this.state.showBillDeliveredConfirmation) {
      const formattedTotal = formatter.currency(this.state.bill.total);
      const totalOrders = this.state.bill.orders.length;
      const bill = this.state.bill;

      return (
        <div style={{ marginTop: '1em' }}>
          <Message headerText="Cerrar cuenta">
            <p style={{ textAlign: 'center', fontSize: '1.2em', marginBottom: '1.5em' }}>
              ¿Estás seguro de cerrar la siguiente cuenta?
            </p>
            
            <p style={{ textAlign: 'center', fontSize: '1.2em', marginBottom: '1.5em' }}>
              <b>{displayTitle(bill)}</b> con <b>{totalOrders}</b> {totalOrders === 1 ? 'artículo' : 'artículos'}
              {hasBillLabel(bill) && (
                <span style={{ display: 'block', fontSize: '0.85em', color: '#666', marginTop: '0.35em', fontWeight: 'normal' }}>
                  ID #{bill.id}
                </span>
              )}
              <br />
              <span style={{ fontSize: '2em', fontWeight: 'bold', display: 'block', margin: '0.5em 0' }}>
                {formattedTotal}
              </span>
            </p>

            <p style={{ textAlign: 'center', color: '#666', fontSize: '1em', marginBottom: '1.5em' }}>
              Al cerrar la cuenta, esta no podrá modificarse.
            </p>
  
            <CancelGoButtons
              cancelFn={ () => this.setState({ showBillDeliveredConfirmation: false }) }
              goText="cerrar cuenta"
              goEnabled={true}
              goFn={this.billDelivered}
              warning={true}
            />
          </Message>
        </div>
      )
    }

    // show delete confirmation
    if (this.state.showDeleteConfirmation) {
      return (
        <div style={{ marginTop: '1em' }}>
          <Message headerText="Eliminar cuenta">
            <p style={{ textAlign: 'center', fontSize: '1.2em', marginBottom: '1.5em' }}>
              ¿Estás seguro de eliminar esta cuenta?
            </p>
            
            <p style={{ textAlign: 'center', fontSize: '1.2em', marginBottom: '1.5em' }}>
              <b>{displayTitle(this.state.bill)}</b>
              {hasBillLabel(this.state.bill) && (
                <span style={{ display: 'block', fontSize: '0.85em', color: '#666', marginTop: '0.35em', fontWeight: 'normal' }}>
                  ID #{this.state.bill.id}
                </span>
              )}
            </p>

            <p style={{ textAlign: 'center', color: '#666', fontSize: '1em', marginBottom: '1.5em' }}>
              Esta acción no se puede deshacer.
            </p>
  
            <CancelGoButtons
              cancelFn={ () => this.setState({ showDeleteConfirmation: false }) }
              goText="eliminar cuenta"
              goEnabled={true}
              goFn={this.deleteBill}
              warning={true}
            />
          </Message>
        </div>
      )
    }

    // Display menu to add orders
    if (this.state.showMenu) {
      return (
        <AddOrdersMenu
          cancelFn={ () => this.setState({ showMenu: false, menuEditOrder: null }) }
          billId={this.state.billId}
          getBill={this.getBill}
          editOrder={this.state.menuEditOrder}
        />        
      );
    }

    let actionButtons = null;

    if (this.state.bill.orders.length > 0) {
      actionButtons = (
        <SubmitButton
          onClick={ () => this.setState({ showBillReceipt: true }) }
          enabled={true}
          style={{
            height: '50px',
            borderRadius: '8px',
            fontSize: '16px',
            marginTop: '15px',
            marginBottom: '15px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)'
          }}
        >
          cobrar cuenta
        </SubmitButton>
      );

      if (this.state.bill.paid_at) {
        actionButtons = (
          <SubmitButton
            onClick={this.deliverBill}
            enabled={pendingOrders.length === 0}
            style={{
              height: '50px',
              borderRadius: '8px',
              fontSize: '16px',
              marginTop: '15px',
              marginBottom: '15px',
              boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)'
            }}
          >
            cerrar cuenta
          </SubmitButton>
        );
      }
    }
    
    return (
      <div>
        <BackLink onClick={() => this.props.history.push('/bills')} />
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '0.5em' }}>
          <div style={{ flex: 1, minWidth: 0, margin: '1.5em 0' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <h2 style={{ marginBottom: 0, marginTop: 0 }}>{displayTitle(this.state.bill)}</h2>
              <InlineEditIconButton
                as={Link}
                to={`/bills/${this.state.billId}/name`}
                ariaLabel="Editar nombre de cuenta"
              />
            </div>
          </div>
          <Button
            circular
            icon
            primary
            onClick={() => this.setState({ showMenu: true, menuEditOrder: null })}
            style={{
              width: '56px',
              height: '56px',
              marginTop: '1em',
              boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexShrink: 0,
            }}
          >
            <Icon name="plus" size="large" />
          </Button>
        </div>

        <div style={{ marginBottom: '1em', display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
          <span style={{ fontSize: '2.5em', fontWeight: 'bold', marginRight: '10px' }}>
            { formatter.currency(this.state.bill.total) }
          </span>
          <div>
            { this.state.bill.paid_at ? (
              <Label color="green">
                PAGADA
              </Label>
              
            ) : (
              <Label color="red">
                SIN PAGAR
              </Label>
            )}
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: '', alignItems: 'center', marginBottom: '2em' }}> 
          <Icon name="clock outline" size='large' />
          <span style={{ fontSize: '1.2em',  }}>
            Abierta
            {' '}
            <TimeAgo
              datetime={this.state.bill.created_at}
              locale="es"
            />
          </span>
        </div>

        <BillProducts
          products={this.state.bill.orders}
          toggleProductReadyFn={ (orderId) => this.toggleProductReady(orderId) }
          deliverBillFn={ (billId) => this.deliverBill(billId) }
          pendingOrders={pendingOrders}
          onEditOrder={ (order) => this.setState({ showMenu: true, menuEditOrder: order }) }
        />

        { actionButtons }
      </div>
    )
  }
}

export default withRouter(BillPage);


{/* <div style={{display:'flex', marginTop:'1em', justifyContent: 'center'}}>
          {!this.state.bill.paid_at && !anyOrderReady && (            
            <Button color='red' onClick={() => this.setState({ showDeleteWarningMessage: true })} style={{marginRight:'0.25em', width:'100%'}}>
              Eliminar Cuenta
            </Button>
          )}          
        </div> */}